import React from 'react';

import { PrimaryButton, SecondaryButton } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { Title } from 'components/delivery-cart-error/styled';
import { DialogMemo } from 'components/dialog';
import { ButtonContainer } from 'components/modal-beeper/styled';
import { Text } from 'pages/cart/details/styled';

interface IUnrecognziedStreetNumberModalProps {
  onDismiss: VoidFunction;
  onConfirm: VoidFunction;
  streetNumber: string;
}

export const UnrecognizedStreetNumberModal = ({
  onDismiss,
  onConfirm,
  streetNumber,
}: IUnrecognziedStreetNumberModalProps) => {
  const { formatMessage } = useIntl();

  return (
    <DialogMemo
      onDismiss={onDismiss}
      bodyComponent={
        <>
          <Title>{formatMessage({ id: 'weCouldntFindYourAddress' })}</Title>
          <Text>{formatMessage({ id: 'isTheStreetNumberCorrect' }, { streetNumber })}</Text>
        </>
      }
      actions={
        <ButtonContainer>
          <PrimaryButton
            fullWidth
            aria-label={formatMessage({ id: 'yesDeliverHere' })}
            onClick={onConfirm}
          >
            {formatMessage({ id: 'yesDeliverHere' })}
          </PrimaryButton>
          <SecondaryButton
            fullWidth
            aria-label={formatMessage({ id: 'noChangeAddress' })}
            onClick={onDismiss}
          >
            {formatMessage({ id: 'noChangeAddress' })}
          </SecondaryButton>
        </ButtonContainer>
      }
      modalAppearanceEventMessage="Street Number Not Validated"
      headingComponent={<></>}
      heading={formatMessage({ id: 'weCouldntFindYourAddress' })}
      body={formatMessage({ id: 'isTheStreetNumberCorrect' }, { streetNumber })}
    />
  );
};
